module.exports = __webpack_public_path__ + "static/img/icon_zanwuwdxy@2x.9028e2af.png";